export const classesList = [
  {
    title: "CIS 5480: Operating Systems Design and Implementation",
    description:
      "Core OS concepts including processes, threads, synchronization and deadlocks, CPU scheduling, virtual memory and paging, file systems, I/O, and virtualization. Emphasis on concurrent programming and systems programming.",
    skills: ["C", "POSIX", "Concurrency", "Threads", "Synchronization", "OS"],
    grade: "*In Progress*",
  },
  {
    title: "CIS 5210: Artificial Intelligence",
    description:
      "Foundations of AI: state-space search, heuristic search, constraint satisfaction, probabilistic reasoning (Bayes nets, HMMs), decision making, and introductory machine learning elements.",
    skills: ["Python", "Search", "Heuristics", "Probability", "AI"],
    grade: "*In Progress*",
  },
  {
    title: "CIS 5500: Database and Information Systems",
    description:
      "Relational model, E/R modeling, SQL, normalization, indexing and hashing, transactions and concurrency control, recovery, and an introduction to query optimization and distributed data systems.",
    skills: [
      "SQL",
      "Database Design",
      "Transactions",
      "Indexing",
      "Normalization",
    ],
    grade: "*In Progress*",
  },
  {
    title: "CIS 3200: Introduction to Algorithms",
    description:
      "Comprehensive study of algorithm design and analysis. Topics include problem-solving strategies, advanced data structures (universal hashing, red-black trees), dynamic programming, amortized analysis, graph algorithms (minimum spanning trees, network flows), NP-completeness, and approximation algorithms.",
    skills: ["CS Theory", "Algorithms"],
    grade: "A+",
  },
  {
    title: "CIS 2400: Introduction to Computer Systems",
    description:
      "Bottom-up exploration of computer systems. Begins with transistors and basic hardware structures, covers machine instructions and low-level programming, and concludes with the C programming language.",
    skills: ["C", "Assembly"],
    grade: "A+",
  },
  {
    title: "ESE 3600: TinyML - Tiny Machine Learning for Embedded Systems",
    description:
      "Introductory course at the intersection of machine learning and IoT. Focuses on implementing ML applications on embedded devices using hardware, sensors, actuators, and specialized software.",
    skills: ["Python", "TensorFlow", "Embedded Systems"],
    grade: "A",
  },
  {
    title: "CIS 5450: Big Data Analytics",
    description:
      "Covers techniques for collecting, wrangling, and structuring large datasets. Emphasis on scalable computation models, distributed frameworks, and modern toolkits for analysis and machine learning.",
    skills: [
      "Python",
      "Pandas",
      "Polars",
      "Database Design",
      "Scikit-Learn",
      "SQL",
    ],
    grade: "A",
  },
  {
    title: "CIS 1210: Data Structures and Algorithms",
    description:
      "Covers core data structures (stacks, queues, maps, trees, graphs) and algorithmic analysis using Java. Includes complexity analysis, runtime evaluation, and construction of efficient algorithms.",
    skills: [
      "CS Theory",
      "Java",
      "Data Structures",
      "Algorithms",
      "Asymptotic Analysis",
    ],
    grade: "A",
  },
  {
    title: "STAT 4300: Probability",
    description:
      "Covers discrete and continuous probability spaces, random variables and distributions, independence, expectation, generating functions, and Markov chains.",
    skills: [],
    grade: "A+",
  },
  {
    title: "CIS 2620: Automata, Computability and Complexity",
    description:
      "Studies the mathematical foundations of computation. Topics include automata theory, computability, computational complexity, and the limits of efficient problem solving.",
    skills: [],
    grade: "A",
  },
  {
    title: "CIS 1600: Mathematical Foundations of Computer Science",
    description:
      "Introduction to mathematical concepts underpinning computer science: sets, functions, counting techniques, discrete probability, expectation, induction, and graph theory.",
    skills: ["CS Theory", "Probability"],
    grade: "A-",
  },
  {
    title: "CIS 1200: Programming Languages & Techniques",
    description:
      "Fast-paced introduction to software design and programming paradigms. Topics include functional programming with OCaml and object-oriented programming with Java.",
    skills: ["Java", "OCaml", "OOP"],
    grade: "A",
  },
];
